const AccountActivationErrorCodes = {
  FIELD_MISSING_PASSWORD: 0x2000100D, // the password field in the viewmodel is not available
  FIELD_MISSING_CONFIRM_PASSWORD: 0x2000100E, // the confirmPassword field in the viewmodel is not available
  FIELD_MISMATCH_PASSWORD: 0x2000100F, // the password and confirmPassword fields do not match
  FIELD_MISSING_EMAIL: 0x20001010, // the email field in the viewmodel is not available
  FIELD_MISSING_CONFIRM_EMAIL: 0x20001011, // the confirm email field in the viewmodel is not available
  FIELD_MISMATCH_EMAIL: 0x20001012, // the email and confirm email fields do not match
  FIELD_MISSING_SECURITY_QUESTION: 0x20001013, // the security question field in the viewmodel is not available
  FIELD_MISSING_SECURITY_ANSWER: 0x20001014, // the security answer field in the viewmodel is not available
  FIELD_INVALID_EMAIL: 0x20001015, // the email field is not valid
  SOAP_CONNECTION_FAILED: 0x20001016, // this means the we were not able to connect to the SOAP server
  UNKNOWN_EXCEPTION: 0x20001017, // there was an unknown exception, no idea what happened but we caught it and logged it
  VIEW_MODEL_MISSING: 0x20001018, // the viewmodel passed in the body is null
  FIELD_EMPTY_USERNAME: 0x20001019, // the username field is empty
  FIELD_EMPTY_PASSWORD: 0x2000101A, // the temporary password field is empty
  ACTIVATION_ERROR: 0x20001020 // Error occured while activation set up.
}

const AccountForgotPasswordErrorCodes = {
  POST_BODY_MISSING: 0x20001001, // (400 BadRequest) - there is no body available in the POST
  FIELD_EMPTY_USERNAME: 0x20001002, // (400 BadRequest) - the username is null or empty string
  USER_NOT_FOUND: 0x20001003, // (400 BadRequest) - SOAP call was successful but there username was most likely not found.
  SOAP_CONNECTION_FAILED: 0x20001004, // (400 BadRequest) - SOAP call was unsuccessful as we could not connect to it
  UNKNOWN_EXCEPTION: 0x20001005 // (400 BadRequest) - SOAP call was unsuccessful and some exception happened but not sure what
}

const AccountLoginErrorCodes = {
  INVALID_LOGIN: 0x10001000, // this means the username and password is incorrect
  SOAP_CONNECTION_FAILED: 0x10001001, // this means the we were not able to connect to the SOAP server
  UNKNOWN_EXCEPTION: 0x10001002, // this is an unknown exception, no idea what happened :(
  ACTIVATION_REQUIRED: 0x10001003, // account requires activation
  SOAP_ERROR: 0x10001004, // unknown error from soap, we just know about username/password incorrect or account activation required
  ACTIVATION_PASSWORD: 0x10001005, // account requires activation but password provided is incorrect
  MAX_PASSWORD_ATTEMPTS: 0x10001006, // account has been locked out because of too many password attempts
  POLICY_RETREIVAL: 0x10001007, // successfully signed in but unable to retreive policy details,
  MULTIPLE_ACCESS: 0x10001008, // someone else is already logged in as the same user
  UNKNOWN_LEGACY_ERROR_BLAME_MARK: 0x10001009 // assumed to be an outdated code
}

const UserProfileErrorCodes = {
  SOAP_CONNECTION_FAILED: 0x20002001, // this means the we were not able to connect to the SOAP server
  UNKNOWN_EXCEPTION: 0x20002002, // there was an unknown exception, no idea what happened but we caught it and logged it
  PROFILE_RETREIVAL: 0x20002003, // means we were unable to get the member profile or member summary
  VIEW_MODEL_MISSING: 0x20002006, // the viewmodel passed in the body is null
  UNAUTHORIZED: 0x20002007, // not authorized to update the profile, signed does not match the userid in the viewmodel
  SOAP_ERROR: 0x20002008 // soap responded with an error, see message for details
}

const MemberSummaryErrorCodes = {
  FIELD_MISSING_MEMBER_ID: 0x20007001, // (400 BadRequest) - there is no memberId in request
  UNAUTHORIZED: 0x20007002, // (400 BadRequest) - When currently logged in user's member Id doesn't match with requested member Id.
  USER_NOT_FOUND: 0x20007003, // (400 BadRequest) - SOAP call was successful but there username was most likely not found.
  SOAP_CONNECTION_FAILED: 0x20007004, // (400 BadRequest) - SOAP call was unsuccessful as we could not connect to it
  UNKNOWN_EXCEPTION: 0x20007005 // (400 BadRequest) - SOAP call was unsuccessful and some exception happened but not sure what
}

const hexStringFromErrorCode = code => {
  return `0x${code.toString(16).toUpperCase()}`
}

export {
  AccountActivationErrorCodes,
  AccountForgotPasswordErrorCodes,
  AccountLoginErrorCodes,
  UserProfileErrorCodes,
  MemberSummaryErrorCodes,
  hexStringFromErrorCode
}



// WEBPACK FOOTER //
// ./src/util/ErrorCodes.js